import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api, setAuthToken } from "../services/api";

// Fetch user from localStorage if it exists
const storedToken = localStorage.getItem("authToken");

export const login = createAsyncThunk("auth/login", async (payload, { rejectWithValue }) => {
  try {
    const { data } = await api.post("/auth/login", payload);
    return data; // { token, user }
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || "Login failed");
  }
});

export const fetchMe = createAsyncThunk("auth/me", async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get("/auth/me");
    return data.user;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || "Session expired");
  }
});

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: storedToken || null,
    user: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout(state) {
      state.token = null;
      state.user = null;
      state.error = null;
      localStorage.removeItem("authToken"); // Remove token from localStorage
      setAuthToken(null); // Remove the token from API requests
    },
    setToken(state, action) {
      state.token = action.payload;
      localStorage.setItem("authToken", action.payload); // Store token in localStorage
      setAuthToken(action.payload); // Set token for API requests
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(login.fulfilled, (s, a) => {
        s.loading = false;
        s.token = a.payload.token;
        s.user = a.payload.user;
        localStorage.setItem("authToken", a.payload.token); // Persist token
        setAuthToken(a.payload.token); // Set token in API requests
      })
      .addCase(login.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload;
      })
      .addCase(fetchMe.fulfilled, (s, a) => {
        s.user = a.payload;
      })
      .addCase(fetchMe.rejected, (s, a) => {
        s.error = a.payload;
        s.token = null;
        s.user = null;
        localStorage.removeItem("authToken"); // Remove token if session expired
        setAuthToken(null); // Remove the token from API requests
      });
  },
});

export const { logout, setToken, clearError } = authSlice.actions;
export default authSlice.reducer;
